/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function(){
  
// POPUP
  $('.popup_item').click(function(){
    $(this).parents('body').addClass('popup_active');
    var popupData = $(this).data('popup');
    $('.product').find('#'+ popupData).addClass('active');
  });

  $('.popup_close').click(function(){
     $(this).parents('body').removeClass('popup_active');
    $('.product_popup_item').removeClass('active');
  });


// Product FAQ

$('.product_faq_question').click(function(){
  $(this).siblings('.product_faq_answer').slideToggle();
  $(this).parents('.product-faq_item').toggleClass('active');
});
$('product-faq:first-of-type').addClass('active');
  $('product-faq:first-of-type .product_faq_answer').slideDown();
  
  $(".product_media_carousel").slick({
   slidesToShow: 1.1,
   infinite:false,
   slidesToScroll: 1,
  arrows:false
  });

// Features accordion
  $('.features_heading').click(function(){
  $(this).siblings('.features_content').slideToggle();
  $(this).parents('.features_item').toggleClass('active');
});


  // Vertical tab
  $('.vertical_title').click(function(){
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var dataTab = $(this).data('tab');
    $(this).parents('.vertical_tab_wrapper').find('#' + dataTab).addClass('active');
    $(this).parents('.vertical_tab_wrapper').find('#' + dataTab).siblings().removeClass('active');
  });

   $(".custom-join-community-slider").slick({
   slidesToShow: 1,
   infinite:true,
   slidesToScroll: 1,
   arrows:true,
   dots: true,
   prevArrow: $('.slick-left-arrow'),
   nextArrow: $('.slick-right-arrow')
  });


  // Product Tab Slider
  function FeaturesCollection(){
     $(".new-featured .featured_collection_slider .product-list__inner").slick({
       slidesToShow: 3,
       infinite:true,
       slidesToScroll: 1,
       arrows:false,
       dots: true,
       responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        }
      ],
      });
  }

  FeaturesCollection();




  // horizontal Tab
    $('.tab-nav-title').click(function(){
    $('.new-featured .featured_collection_slider .product-list__inner').slick('unslick');
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var dataTab = $(this).data('tab');
    $(this).parents('.shopify-section--featured-collections').find('#' + dataTab).addClass('active');
    $(this).parents('.shopify-section--featured-collections').find('#' + dataTab).siblings().removeClass('active');
        FeaturesCollection();
  });


  
  $('.custom-testimonial-list__wrapper').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg fill=none height=52 viewBox="0 0 18 52"width=18 xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_26_454)><path d="M17.2168 15.397C17.4029 15.583 17.4959 15.7969 17.4959 16.0387C17.4959 16.2805 17.4029 16.4944 17.2168 16.6805L6.25144 27.6459L17.2168 38.6113C17.4029 38.7973 17.4959 39.0112 17.4959 39.253C17.4959 39.4948 17.4029 39.7087 17.2168 39.8947L15.8217 41.2898C15.6357 41.4758 15.4218 41.5688 15.18 41.5688C14.9382 41.5688 14.7243 41.4758 14.5383 41.2898L1.53604 28.2876C1.35002 28.1016 1.25702 27.8877 1.25702 27.6459C1.25702 27.404 1.35002 27.1901 1.53604 27.0041L14.5383 14.0019C14.7243 13.8159 14.9382 13.7229 15.18 13.7229C15.4218 13.7229 15.6357 13.8159 15.8217 14.0019L17.2168 15.397Z"fill=#262020 /></g><defs><clipPath id=clip0_26_454><rect fill=white height=50 transform="matrix(1 0 0 -1 0 50.8604)"width=17.86 /></clipPath></defs></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg fill=none height=51 viewBox="0 0 18 51"width=18 xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_26_459)><path d="M16.4641 27.0041C16.6501 27.1901 16.7431 27.404 16.7431 27.6459C16.7431 27.8877 16.6501 28.1016 16.4641 28.2876L3.46186 41.2898C3.27585 41.4758 3.06194 41.5688 2.82012 41.5688C2.57831 41.5688 2.36439 41.4758 2.17838 41.2898L0.78329 39.8947C0.597278 39.7087 0.504272 39.4948 0.504272 39.253C0.504272 39.0112 0.597278 38.7973 0.78329 38.6113L11.7487 27.6459L0.78329 16.6805C0.597278 16.4944 0.504272 16.2805 0.504272 16.0387C0.504272 15.7969 0.597278 15.583 0.78329 15.397L2.17838 14.0019C2.36439 13.8159 2.57831 13.7229 2.82012 13.7229C3.06194 13.7229 3.27585 13.8159 3.46186 14.0019L16.4641 27.0041Z"fill=#262020 /></g><defs><clipPath id=clip0_26_459><rect fill=white height=50 transform="matrix(1 0 0 -1 0.140137 50.8604)"width=17.86 /></clipPath></defs></svg></button>'
  });
});


  function stickyatc() {
    document.getElementById('product-title').scrollIntoView({ behaviour: 'smooth' });
  }

  var _sticky = document.getElementById('custom_sticky_atc');
  window.addEventListener('scroll', () => {
    var activationHeight = window.innerWidth <= 768 ? 1600 : 1230;

    if (window.scrollY >= activationHeight) {
      if (_sticky.classList.contains('active')) return;
      _sticky.classList.add('active');
    } else {
      if (!_sticky.classList.contains('active')) return;
      _sticky.classList.remove('active');
    }
  });

 // Free Gift Product
  $(document).ready(function(){

      if ($('.option_selected-js').hasClass('add_gift-js')) {
        $('.gift-input--js').prop("disabled", false);
      }
      else {
        $('.gift-input--js').prop("disabled", true);
      }


document.addEventListener('variant:changed', function(event) {
    var variantTitle = event.detail.variant.title;

    if ((variantTitle.includes("2") || variantTitle.includes("3")) && $('.block-swatch.main-block-js').hasClass('add_gift-js')) {
        $('.gift-input--js').prop("disabled", false);
    } else {
        $('.gift-input--js').prop("disabled", true);
    }
});
    
    

  function isCart() {
  if (document.URL.includes("/cart")) return true;
  else false;
}

    $(document).on("click", ".link.main-product--true", function(event) {
  event.preventDefault();
  const $this = $(this);
  const updates = {};
  updates[$this.data("line-id")] = 0;

  if (isCart()) {
    $this.parents(".cart-line-item").find(".list-disc input.freegiftId").each(function() {
      updates[$(this).val()] = 0;
    });
  } else {
    $this.closest(".line_item_content").find(".product-item-meta__property input.freegiftId").each(function() {
      updates[$(this).val()] = 0;
    });
  }

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
  .then(response => response.json())
  .then(dataResponse => {
    let itemCount = dataResponse.item_count;
    // setTimeout(() => {
    //   $countBubble.text(itemCount);
    // }, 2500);

    if (isCart()) {
      location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
               }));
    }
  })
  .catch(error => {
      console.error("Error:", error);
    });
  
});


// Function to increase quantity
function increaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) + 1;
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let vId = $(this).val();
      updates.updates[vId] = quantity;
    });
  }

  cartUpdated(updates);
}

// Function to decrease quantity
function decreaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) - 1;
  if (quantity < 0) {
    quantity = 0;
  }
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let vId = $(this).val();
      updates.updates[vId] = quantity;
    });
  }

  cartUpdated(updates);
}


// Function to update cart
function cartUpdated(updates) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: $.param(updates)
  })
.then(response => {
  if (response.ok) {
    return response.json().then(dataResponse => {
      let itemCount = dataResponse.item_count;
      // setTimeout(() => {
      //   $countBubble.text(itemCount);
      // }, 2500);

      if (isCart()) {
        location.reload();
      } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
               }));
        
      }
      
      $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    });
  } else {
    console.log(response);
    $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    throw new Error('Error updating cart');
  }
})
  .catch((error) => {
    $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    console.error('Error:', error);
    // Handle error here
  });
}

// Event listeners
$(document).on('click', '.quantity-selector__button.minus', function(event) {
  event.preventDefault();
  decreaseQuantity($(this));
});

$(document).on('click', '.quantity-selector__button.plus', function(event) {
  event.preventDefault();
  increaseQuantity($(this));
});
    
    
    

  });

$(document).ready(function(){

  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant;
    let compare_at_price = '';
    if (variant.compare_at_price != null) {
       compare_at_price = variant.compare_at_price / 100;
       compare_at_price = compare_at_price.toFixed(2);
    } else {
      $('.compare___price').hide();
      $('.spare__amount.label--highlight').hide();
    }
    let price = variant.price / 100;
    price = price.toFixed(2);
    if (variant.compare_at_price != null) {
    $('.compare___price').show();
    $('.spare__amount.label--highlight').show();
    let saveAmount = '';
    saveAmount = compare_at_price - price;
    saveAmount = saveAmount.toFixed(2);
    $('.compare___price').text('$'+ compare_at_price);
      
    $('.spare__amount.label--highlight').text('SAVE $'+ saveAmount)
    }
    $('.variant___price').text('$'+ price);
    
  });
 
  
$('.faq-question').click(function() {
  $(this).siblings().slideToggle();
  $(this).parents('.faq__item,.faq-item').toggleClass('active');
  $(this).parents('.faq__item,.faq-item').siblings().find('.faq-answer').slideUp();
  $(this).parents('.faq__item,.faq-item').siblings().removeClass('active');
});
  });
$(document).ready(function(){
    const productVariantElement = document.querySelector('product-variants');
    let PreselectedVariantId = $('product-variants').attr('preselected_id');
    PreselectedVariantId = parseInt(PreselectedVariantId);
    console.log(PreselectedVariantId);
    if (PreselectedVariantId) {
      productVariantElement.selectVariant(PreselectedVariantId);
    }
});


// // Code below has been updated by Naveed to resolve the cart drawer issue .

//   document.addEventListener('cart:updated', function(event) {
//     var cart = event.detail.cart; 
//     console.log(cart);
//     setTimeout(function() {
//         checkAndRefreshCartDrawer(cart);
//     }, 500)
// });

// function checkAndRefreshCartDrawer(cart) {

//     var freeGiftProductHandles = ['sleep-sca_clone_freegift', 'debloat-sca_clone_freegift'];

//     var anyFreeGiftsInCart = freeGiftProductHandles.some(function(handle) {
//         return cart.items.some(function(item) {
//             return item.handle === handle;
//         });
//     });


//     var drawerContainsFreeGift = freeGiftProductHandles.some(function(handle) {
//         return $('.drawer__content').find(`[data-cart-item-handle="${handle}"]`).length > 0;
//     });

//     if ((anyFreeGiftsInCart && !drawerContainsFreeGift) || (!anyFreeGiftsInCart && drawerContainsFreeGift)) {
       
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//           bubbles: true
//         }));
//       console.log('Cart drawer refreshed due to a mismatch between the cart and the drawer.');
//     } else {
      
//         console.log('Cart and drawer are in sync. No refresh needed.');
//     }
// }

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() { 
   document.body.style.visibility = 'visible';
  document.body.style.backgroundColor = '#eae6e3';
             }, 200);
}, false);




$(document).ready(function() {
  // Initialize the Slick slider
  $('.videos_main').slick({
    slidesToShow: 1,
    dots: true,
    arrows: false
  });

  // Click event to play video when play icon is clicked
  $('.play_icon').click(function() {
    $(this).parents('.video-wrapp').addClass('active');
    var video = $(this).siblings('video').get(0); 
    if (video) {
      video.play().catch(function(error) {
        console.error('Error attempting to play the video:', error);
      });
    } else {
      console.error('No video element found.');
    }
  });

  // Unified click event for video control
  $('.video-control').click(function() {
    var parentItem = $(this).parents('.video-item');
    var video = $(this).siblings('video').get(0); 
    if (video) {
      if (video.paused) {
        video.play().catch(function(error) {
          console.error('Error attempting to play the video:', error);
        });
        parentItem.addClass('active');
      } else {
        video.pause();
        parentItem.removeClass('active');
      }
    } else {
      console.error('No video element found.');
    }
  });

  // Function to handle the play/pause functionality
  function toggleVideo(videoElement, parentItem) {
    if (videoElement.paused) {
      videoElement.play().catch(function(error) {
        console.error('Error attempting to play the video:', error);
        alert('Sorry, there was an error playing the video.');
      });
      parentItem.addClass('active');
    } else {
      videoElement.pause();
      parentItem.removeClass('active');
    }
  }

  // Function to pause all other videos
  function pauseAllOtherVideos(currentVideo) {
    const videos = $('.video_review_item video');
    videos.each(function() {
      const videoParent = $(this).parents('.video_review_item');
      if (this !== currentVideo) {
        if (!this.paused) {
          this.pause();
        }
        videoParent.removeClass('active');
      }
    });
  }

  // Click event for the video element
  $('.video_review_item video').click(function() {
    const currentVideo = this;
    const parentItem = $(this).parents('.video_review_item');
    
    // Pause all other videos and remove 'active' class from their parent elements
    pauseAllOtherVideos(currentVideo);
    
    // Toggle playback of the current video
    toggleVideo(currentVideo, parentItem);
  });

  // Click event for the control image
  $('.video_review_item .video-control-img').click(function() {
    const parentItem = $(this).parents('.video_review_item');
    const currentVideo = parentItem.find('video')[0];
    if (currentVideo) {
      // Pause all other videos
      pauseAllOtherVideos(currentVideo);
      
      // Toggle playback of the current video
      toggleVideo(currentVideo, parentItem);
    }
  });
});


$(document).ready(function() {
    // Function to get a cookie by name
    function getCookie(name) {
        var cookieArr = document.cookie.split(";");
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if (name === cookiePair[0].trim()) {
                console.log('Found cookie:', cookiePair[0].trim(), cookiePair[1]); // Debugging line
                return decodeURIComponent(cookiePair[1]); // Decode and return the cookie value
            }
        }
        console.log('Cookie not found:', name); // Debugging line
        return null; // Return null if cookie not found
    }

    // Check if the cookie is set on page load
    var collectionList = getCookie('collectionList');
    console.log('Collection List:', collectionList); // Debugging line

    // If the cookie is not set, set the first tabs-nav__item to true
    if (!collectionList || collectionList.trim() === '') {
        $('.custom-features-collection .tabs-nav__item:first-child').attr('aria-expanded', 'true');
        // $('.tabs-nav__item:last-child').siblings().removeAttr('aria-expanded', 'true');
    } else {
        $('.custom-features-collection .tabs-nav__item').each(function() {
            var tabText = $(this).text().trim(); // Get the text of the tab
            if (tabText === collectionList) {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });
    }

    // Manage visibility of featured collections based on aria-expanded
    updateFeaturedCollections();

    $('.list-collections__item').click(function() {
        var text = $(this).find('.text-withicon span').text();  
        document.cookie = "collectionList=" + encodeURIComponent(text) + "; path=/; max-age=3600";
        console.log('Cookie set:', document.cookie); // Log all cookies

        // Update aria-expanded attributes after clicking
        collectionList = getCookie('collectionList');

        $('.custom-features-collection .tabs-nav__item').each(function() {
            var tabText = $(this).text().trim(); // Get the text of the tab
            if (tabText === collectionList) {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });

        // Update visibility of featured collections
        updateFeaturedCollections();
    });


    // Function to update visibility of featured collections
    function updateFeaturedCollections() {
        $('.custom-features-collection .tabs-nav__item').each(function() {
            if ($(this).attr('aria-expanded') === 'true') {
                var controlsId = $(this).attr('aria-controls'); // Get aria-controls attribute
                // Show the corresponding featured collection
                $('#' + controlsId).removeAttr('hidden'); 
            } else {
                var controlsId = $(this).attr('aria-controls'); // Get aria-controls attribute
                // Hide the corresponding featured collection
                $('#' + controlsId).attr('hidden', true); 
            }
        });
    }

    $('.header__linklist-link, .mobile-nav__item, .linklist__item').click(function() {
        document.cookie = "collectionList=; path=/; max-age=0";       
    });
});